module.exports = __webpack_public_path__ + "static/media/kerry-lg.456cdb75.jpg";